<ngx-empty-full-layout>
      <router-outlet></router-outlet>
  
</ngx-empty-full-layout>
   

 
 
 
